import { defineVersionedStorage } from '@heidi/runtime/storage';
import { getUserStorageScope } from '@heidi/utils/jotai-storage';

type AcknowledgementsByUser = Record<string, true>;

const acknowledgementStorage = defineVersionedStorage<AcknowledgementsByUser>({
  key: 'heidi.workChat.autoApproveDisclaimerAcknowledgements.v1',
  version: 1,
  fallback: {},
  validate: (value): value is AcknowledgementsByUser =>
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    Object.values(value).every((acknowledged) => acknowledged === true),
});

/** True once this version of the explanation has been accepted in this browser. */
export const hasAcknowledgedAutoApproveDisclaimer = (): boolean => {
  const userScope = getUserStorageScope();
  return userScope !== null && acknowledgementStorage.read()[userScope] === true;
};

/** Persist acceptance for the signed-in user. Bump the storage version when the safety boundary changes. */
export const acknowledgeAutoApproveDisclaimer = (): void => {
  const userScope = getUserStorageScope();
  if (userScope === null) return;

  acknowledgementStorage.write({
    ...acknowledgementStorage.read(),
    [userScope]: true,
  });
};
